import { createContext, ReactNode, useContext, useMemo } from "react";

export interface ChatEntityFeatureFlags {
  isMomentsEnabled: boolean;
  isSwapsEnabled: boolean;
}

/**
 * Mentors must always see moment/swap chat rows for entities that already exist.
 * Hub create/list still use the raw flags.
 */
const CHAT_ENTITY_FLAGS: ChatEntityFeatureFlags = {
  isMomentsEnabled: true,
  isSwapsEnabled: true,
};

const ChatEntityFeatureFlagsContext =
  createContext<ChatEntityFeatureFlags>(CHAT_ENTITY_FLAGS);

export function ChatEntityFeatureFlagsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const value = useMemo(() => CHAT_ENTITY_FLAGS, []);

  return (
    <ChatEntityFeatureFlagsContext.Provider value={value}>
      {children}
    </ChatEntityFeatureFlagsContext.Provider>
  );
}

export function useChatEntityFeatureFlags() {
  return useContext(ChatEntityFeatureFlagsContext);
}
